import { COMMITMENT_TYPES, CommitmentType } from '@vy/types';

import { raiseUnreachable } from '@vy/utils';

export function getCommitmentLabel(commitmentType: CommitmentType): string {
  switch (commitmentType) {
    case COMMITMENT_TYPES.Price:
      return 'Commitment';
    case COMMITMENT_TYPES.Units:
      return 'Commitment units';
    default:
      return raiseUnreachable(commitmentType);
  }
}
